"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_CHECKS = exports.CHECK_MOVE_FAILED = exports.CHECK_MOVE_SUCCESS = exports.CHECK_MOVE_REQUEST = exports.CHECK_COPY_FAILED = exports.CHECK_COPY_SUCCESS = exports.CHECK_COPY_REQUEST = void 0;
exports.CHECK_COPY_REQUEST = '@sok/project/permission-checks/CHECK_COPY_REQUEST';
exports.CHECK_COPY_SUCCESS = '@sok/project/permission-checks/CHECK_COPY_SUCCESS';
exports.CHECK_COPY_FAILED = '@sok/project/permission-checks/CHECK_COPY_FAILED';
exports.CHECK_MOVE_REQUEST = '@sok/project/permission-checks/CHECK_MOVE_REQUEST';
exports.CHECK_MOVE_SUCCESS = '@sok/project/permission-checks/CHECK_MOVE_SUCCESS';
exports.CHECK_MOVE_FAILED = '@sok/project/permission-checks/CHECK_MOVE_FAILED';
exports.RESET_CHECKS = '@sok/project/permission-checks/RESET_CHECKS';
//# sourceMappingURL=permissionChecks.js.map